import { getNestedTranslation } from '@colonist/i18n';
import { EnumUtils } from '@colonist/utils';
import * as leaderboardTypes from '@colonist/leaderboard-types';
/**
 * @deprecated Import RankedDivisionTypes from @colonist/leaderboard-types
 */ export const RankedDivisionTypes = leaderboardTypes.RankedDivisionTypes;
export function getRankedDivisionText(rankedDivision) {
    const rankedDivisionKey = EnumUtils.getEnumKey(rankedDivision, RankedDivisionTypes);
    return {
        key: `strings:leaderboardPage.rankedDivision.${rankedDivisionKey}`
    };
}
/**
 * @deprecated Import RankedSubDivisionTypes from @colonist/leaderboard-types
 */ export const RankedSubDivisionTypes = leaderboardTypes.RankedSubDivisionTypes;
export function getRankedFullDivisionText(rankedDivision, rankedSubDivision) {
    const subDivisionName = rankedSubDivision == RankedSubDivisionTypes.None ? '' : RankedSubDivisionTypes[rankedSubDivision];
    return getNestedTranslation({
        key: 'strings:leaderboardPage.rankedFullDivision'
    }, {
        rankedDivision: getRankedDivisionText(rankedDivision),
        rankedSubDivision: {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: subDivisionName
            }
        }
    });
}
export var LeaderboardCategoryStringID = /*#__PURE__*/ function(LeaderboardCategoryStringID) {
    LeaderboardCategoryStringID["Global"] = "Global";
    LeaderboardCategoryStringID["Continent"] = "Continent";
    LeaderboardCategoryStringID["Country"] = "Country";
    LeaderboardCategoryStringID["CountryRegion"] = "Country_Region";
    LeaderboardCategoryStringID["Friends"] = "Friends";
    return LeaderboardCategoryStringID;
}({});
